import { DateTime } from 'luxon';

import { DateHelper } from '../helpers/DateHelper';

class InstallationData {
  constructor(params) {
    this.productId = String(params.productId);
    this.selectedOptions = (params.selectedOptions || []).map(item => ({
      id: `${item.date}-${item.startHour}-${item.endHour}`,
      amount: item.amount,
      date: DateTime.fromISO(item.date),
      endHour: item.endHour,
      endHourString: DateHelper.militaryHourToString(item.endHour),
      extraCost: item.extraCost,
      startHour: item.startHour,
      startHourString: DateHelper.militaryHourToString(item.startHour),
    }));
  }
}

export { InstallationData };



// WEBPACK FOOTER //
// ./src/models/InstallationData.js